let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hwB1b")).then(() => parcelRequire('d88YX'));